module.exports = __webpack_public_path__ + "static/media/rupee-sign.5ec2c34c.svg";